export default (type, ...params) => `${type}:${params.join('-')}`



// WEBPACK FOOTER //
// ./lib/utils/format-request-key.js